import React from 'react';

import './index.css';

import Navbar from './assets/components/Navbar';
import Landing from './assets/components/Landing';
import AboutMe from './assets/components/AboutMe';
import Experiences from './assets/components/Experiences';
import Projects from './assets/components/Projects';
import Contact from './assets/components/Contact';
import Footer from './assets/components/Footer';
import Reveal from './assets/components/Reveal';

function App() {

  return (
    <>
      <Navbar />
      <div className="container mx-auto px-8 font-sans">
        <Landing />
        <Reveal>
          <AboutMe />
        </Reveal>
        <Reveal>
          <Experiences />
        </Reveal>
        <Reveal>
          <Projects />
        </Reveal>
        <Reveal>
          <Contact />
        </Reveal>
      </div>
      <Footer />
    </>
  );
}

export default App;
